import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconUndo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "10 10 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.3787 14.6213C11.9882 15.0118 11.9882 15.645 12.3787 16.0355L15.2071 18.864C15.5977 19.2545 16.2308 19.2545 16.6213 18.864C17.0119 18.4734 17.0119 17.8403 16.6213 17.4497L15.6719 16.5003H18.9142C22.7802 16.5003 25.9142 19.6343 25.9142 23.5003V27.5003C25.9142 28.0526 26.3619 28.5003 26.9142 28.5003C27.4665 28.5003 27.9142 28.0526 27.9142 27.5003V23.5003C27.9142 18.5297 23.8848 14.5003 18.9142 14.5003H15.3282L16.6213 13.2071C17.0119 12.8166 17.0119 12.1834 16.6213 11.7929C16.2308 11.4024 15.5977 11.4024 15.2071 11.7929L12.3787 14.6213Z",
		fill: "#E0E0E0"
	})
});
export default SvgIconUndo;
